import React from 'react';
import { Divider, List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Footer = (props) => {
  const { isAuthed } = props;
  if (isAuthed) {
    return (
      <div className='footer'>
        <p>
          some icons made by
          <a href='https://smashicons.com'> smashicons </a>
        </p>
      </div>
    )
  } else {
    return (
      <div className='landing-footer footer'>
        <Divider />
        <List horizontal bulleted>
          <List.Item>
            <Link to='/faq'>FAQ</Link>
          </List.Item>
          <List.Item>
            <a href='mailto:contact@winno.io' target='_top'>contact@winno.io</a>
          </List.Item>
          <List.Item>
            <Link to='/privacy'>Privacy Policy</Link>
          </List.Item>
        </List>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js